import { XMarkIcon } from "@heroicons/react/20/solid"
import { useTranslation } from "@/(front-desk)/hooks/useTranslation"
import locales from "@/(front-desk)/(pages)/information/information.i18n"
import ImageLoader from "@/(front-desk)/components/ImageLoader"
import classNames from "classnames"
import dayjs from "dayjs"

export default function ActivityDetail(props) {

    const { info, setInfo } = props
    const { translations } = useTranslation(locales)
    const content = translations.activities

    return (
        <div
            className="popup"
            onClick={(e) => {e.target.className === 'popup' && setInfo(null)}}
        >
            <div className={classNames('popup-content flex items-center justify-center overflow-hidden')}>
                <div className="activity-content w-full">
                    <button
                        className="absolute right-4 top-4 bg-white rounded-full p-2 z-[1]"
                        onClick={() => {setInfo(null)}}
                    >
                        <XMarkIcon className="w-[2rem]" />
                    </button>
                    { (info.banner || info.cover) &&
                        <ImageLoader
                            containerClassName="!h-[25rem]"
                            src={info.banner || info.cover}
                        />
                    }
                    <div className="text-content flex flex-col gap-4 p-[3rem]">
                        <div className="title !text-white text-[2.5rem] font-bold">{info.name}</div>
                        <div className="flex flex-col gap-2">
                            { info.speakers?.length > 0 &&
                                <div className="text-black-500 flex gap-2">
                                    <b className="whitespace-nowrap">
                                        {content?.speaker_title}
                                    </b>
                                    <div> | </div>
                                    <div className="flex gap-2 flex-wrap">
                                        { info.speakers?.map((speaker) => (
                                            <div key={`speaker-${speaker.guest.name}`}>
                                                <div className="">{speaker.guest.name}</div>
                                                <div className="mb-2">（{speaker.guest.unit} {speaker.guest.title}）</div>
                                                <div className="">{speaker.guest.introduction}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            {/* { info.host?.length > 0 &&
                                <div className="text-black-500 flex gap-2">
                                    <b className="whitespace-nowrap">主持</b>
                                    <div> | </div>
                                    <span className="flex gap-2 flex-wrap">
                                        {info.host?.map((host) => {
                                            return (
                                                <span key={`activity-${host.name}`}>
                                                    {host.name}（{host.company} {host.job_title}）
                                                </span>
                                            )
                                        })}
                                    </span>
                                </div>
                            } */}
                            { info.start_time &&
                                <div className="text-black-500 flex gap-2">
                                    <b className="whitespace-nowrap">
                                        {content?.time_title}
                                    </b>
                                    <div> | </div>
                                    {dayjs(info.start_time).format('YYYY.MM.DD ')}
                                    {translations.weekday?.[dayjs(info.start_time).format('d')]}
                                    {dayjs(info.start_time).format(' HH:mm')}-{dayjs(info.end_time).format('HH:mm')}
                                </div>
                            }
                            { info.location &&
                                <div className="text-black-500 flex gap-2">
                                    <b className="whitespace-nowrap">
                                        {content?.location_title}
                                    </b>
                                    <div> | </div>
                                    {info.location}
                                </div>
                            }
                            {/* { info.fee &&
                                <div className="text-black-500 flex gap-2">
                                    <b className="whitespace-nowrap">報名</b>
                                    <div> | </div>
                                    {info.fee }
                                </div>
                            } */}
                        </div>
                        <div className="text-white font-light whitespace-pre-wrap">
                            {info.description}
                        </div>
                        <div className="flex justify-end w-full mt-8">
                            { info.signup_link
                                ?
                                <a
                                    className={classNames('btn btn-main btn-round', {
                                        'brightness-[0.85] opacity-[0.5] pointer-events-none': dayjs(info.end_time).isBefore(dayjs())
                                    })}
                                    href={info.signup_link}
                                    target="_blank"
                                    title={`${content?.signup?.link_title}-${info.name}`}
                                    >{content?.signup?.link_name}</a>
                                :
                                <div
                                    className="text-black-300"
                                >{content?.signup?.no_required}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
